'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002econfig$0024$002dFetch$002dConfig from "./presto.config$-Fetch-Config.js";
import * as $j_presto$002econfig$0024$002dLogin$002dConfig from "./presto.config$-Login-Config.js";
import * as $j_presto$002econfig$0024$002dPresto$002dConfig from "./presto.config$-Presto-Config.js";
import * as $j_presto$002econfig$0024$002dTurnstile$002dConfig from "./presto.config$-Turnstile-Config.js";
var $p;
/** @constructor */
function $c_Lpresto_config$() {
  this.rO = null;
  $n_Lpresto_config$ = this;
  var firebaseProdOptions = (() => {
    var this$1 = ({});
    this$1.appId = null;
    this$1.apiKey = null;
    this$1.authDomain = null;
    this$1.projectId = null;
    this$1.storageBucket = null;
    this$1.messagingSenderId = null;
    this$1.appId = "1:48027740555:web:e3b19769c605ebb774678e";
    this$1.apiKey = "AIzaSyAsUt1cL6SEFg4Ce0F55rXkMXwMGL-pdvs";
    this$1.authDomain = "oystr-presto-test.firebaseapp.com";
    this$1.projectId = "oystr-presto-test";
    this$1.storageBucket = "oystr-presto-test.appspot.com";
    this$1.messagingSenderId = "48027740555";
    return this$1;
  })();
  var firebaseDevOptions = (() => {
    var this$2 = ({});
    this$2.appId = null;
    this$2.apiKey = null;
    this$2.authDomain = null;
    this$2.projectId = null;
    this$2.storageBucket = null;
    this$2.messagingSenderId = null;
    this$2.appId = "1:719515434696:web:18fb755c29a23762f06ffd";
    this$2.apiKey = "AIzaSyANn8f6bvWqQ1jQWm13fA6cS9LqfdmB25U";
    this$2.authDomain = "presto-dev-env-1.firebaseapp.com";
    this$2.projectId = "presto-dev-env-1";
    this$2.storageBucket = "presto-dev-env-1.appspot.com";
    this$2.messagingSenderId = "719515434696";
    return this$2;
  })();
  var prod = new $j_presto$002econfig$0024$002dPresto$002dConfig.$c_Lpresto_config$PrestoConfig("Presto", "https://console.presto.oystr.com.br", new $j_presto$002econfig$0024$002dFetch$002dConfig.$c_Lpresto_config$FetchConfig("https://console.presto.oystr.com.br/api", "https://console.presto.oystr.com.br/events"), new $j_presto$002econfig$0024$002dLogin$002dConfig.$c_Lpresto_config$LoginConfig(5000), firebaseProdOptions, new $j_presto$002econfig$0024$002dTurnstile$002dConfig.$c_Lpresto_config$TurnstileConfig("0x4AAAAAADl_4D0cjwU8H5vD"));
  var dev = new $j_presto$002econfig$0024$002dPresto$002dConfig.$c_Lpresto_config$PrestoConfig("Presto Dev", "https://dev.presto.oystr.com.br", new $j_presto$002econfig$0024$002dFetch$002dConfig.$c_Lpresto_config$FetchConfig("https://dev.presto.oystr.com.br/api", "https://dev.presto.oystr.com.br/events"), prod.x6, firebaseDevOptions, prod.Du);
  var fetch$1 = new $j_presto$002econfig$0024$002dFetch$002dConfig.$c_Lpresto_config$FetchConfig("http://localhost:9000", "http://localhost:9001");
  var turnstile$1 = new $j_presto$002econfig$0024$002dTurnstile$002dConfig.$c_Lpresto_config$TurnstileConfig("1x00000000000000000000AA");
  var local = new $j_presto$002econfig$0024$002dPresto$002dConfig.$c_Lpresto_config$PrestoConfig("Presto Local Dev", "http://localhost:5173", fetch$1, prod.x6, firebaseDevOptions, turnstile$1);
  var $x_1;
  switch (window.location.host) {
    case "localhost:5173":
    case "127.0.0.1:5173": {
      var $x_1 = local;
      break;
    }
    case "dev.presto.oystr.com.br": {
      var $x_1 = dev;
      break;
    }
    default: {
      var $x_1 = prod;
    }
  }
  this.rO = $x_1;
  console.info((("'" + this.rO.Dt) + "'"));
}
export { $c_Lpresto_config$ as $c_Lpresto_config$ };
$p = $c_Lpresto_config$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_config$;
/** @constructor */
function $h_Lpresto_config$() {
}
export { $h_Lpresto_config$ as $h_Lpresto_config$ };
$h_Lpresto_config$.prototype = $p;
var $d_Lpresto_config$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_config$, "presto.config$", ({
  Vd: 1
}));
export { $d_Lpresto_config$ as $d_Lpresto_config$ };
var $n_Lpresto_config$;
function $m_Lpresto_config$() {
  if ((!$n_Lpresto_config$)) {
    $n_Lpresto_config$ = new $c_Lpresto_config$();
  }
  return $n_Lpresto_config$;
}
export { $m_Lpresto_config$ as $m_Lpresto_config$ };
//# sourceMappingURL=presto.config$.js.map
